const readAsDataUrlAsync = async files => {
    const filePromises = files.map(
        file =>
            // Return a promise per file
            new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = async () => {
                    resolve(reader.result);
                };
                reader.onerror = error => {
                    reject(error);
                };
                reader.readAsDataURL(file);
            })
    );
    const fileInfos = await Promise.all(filePromises);

    return fileInfos;
};

export default readAsDataUrlAsync;
